















import { Component, Vue } from 'vue-property-decorator';

import { getInstance } from '@/services/auth0/useAuth0';
import { VueAuth0Wrapper } from '@/services/auth0/VueAuth0Wrapper';

import AppBar from '@/components/AppBar/AppBar.vue';
import AppList from '@/components/AppList/AppList.vue';
import AppLoader from '@/components/AppLoader/AppLoader.vue';
import Notifier from '@/components/Notifier/Notifier.vue';
import SplashScreen from '@/components/SplashScreen/SplashScreen.vue';

@Component({
  components: {
    AppBar,
    AppList,
    AppLoader,
    Notifier,
    SplashScreen,
  },
  metaInfo() {
    return {
      title: 'AppStore',
      titleTemplate: '%s – AppStore',
    };
  },
})
export default class App extends Vue {
  public beforeCreate(): void {
    const storageKey = 'iLabs.appStore.darkMode.enabled';
    const storage = window.localStorage.getItem(storageKey);

    if (!storage) {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(this.$vuetify.theme.dark));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }

      return;
    }

    this.$vuetify.theme.dark = JSON.parse(storage);
  }

  public created(): void {
    this.init(this.loadTokenIntoStore);
  }

  async loadTokenIntoStore(instance: VueAuth0Wrapper): Promise<void> {
    const token = await instance.getTokenSilently({});
    this.$store.commit('auth/setToken', token);
  }

  public init(callback: (instance: VueAuth0Wrapper) => Promise<void>) {
    const instance = getInstance();

    instance.$watch('loading', (loading) => {
      if (loading === false) {
        callback(instance);
      }
    });
  }
}
